<template>
  <div class="add_warp">
    <div>
      <div class="courseInfo">基础信息</div>
      <formCustom
        :data="baseHeaders"
        :bindProps="{ 'label-width': '124px', 'scroll-to-error': true }"
        :ruleForm.sync="baseInfoForm"
        :formRef.sync="baseInfoFormRef"
      >
      </formCustom>
    </div>
    <div>
      <div class="courseInfo">使用规则 <span style="color:red;font-size:12px; margin-left:14px;">注意：“领取时间”的结束时间必须小于“使用时间”的结束时间</span> </div>
      <formCustom
        :data="headerRule"
        :bindProps="{ 'label-width': '124px', 'scroll-to-error': true }"
        :ruleForm.sync="useRuleForm"
        :formRef.sync="useRuleFormRef"
      >
      </formCustom>
    </div>
    <div class="from_item_con">
      <el-button @click="resetForm()">取消</el-button>
      <el-button style="margin-left: 120px" type="primary" @click="submitForm()"
        >保存</el-button
      >
    </div>
   <template v-if="dyGroupAuths">
    <bind-dy
        v-model="dyGroupAuths"
        :selectInfo.sync="selectInfo"
        :selectIds.sync="useRuleForm.dycodeids"
    ></bind-dy>
   </template>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import virtualizedSelect from "../../../components/virtualizedSelect/virtualizedSelect.vue";
import formCustom from "../../../components/useTable/customForm";
import cusRadio from "./components/cusRadio/cusRadio.vue";
import bindDy from "./components/bindDy/bindDy.vue";
import { strLength } from "@/utils/index";
import api from "@/api/common/help";
import { cloneDeep } from "lodash-unified";

const formProps = {
  style: {
    marginBottom: "0",
    marginRight: "16px",
  },
};
export default {
  components: {
    formCustom,
    cusRadio,
    virtualizedSelect,
    bindDy,
  },
  data() {
    return {
      selectInfo: [],
      baseInfoForm: {
        name: "", //优惠券名称
        discount_amount: "",
        discount_type: 1, //优惠类型（1：立减券；2：满减券；）
        consume_desc: "", //使用须知 （长度15以内）
        min_pay_amount: 0, //满减门槛金额
      },
      useRuleForm: {
        get_time: [],
        valid_type: 1, // 1：固定时间 2：领取后多少时间内有效
        valid_duration: "",
        use_time_range: [],
        getscene: 1,
        product_id: "",
        dycodeids: [],
      },
      baseInfoFormRef: {},
      useRuleFormRef: {},
      baseHeaders: [
        {
          label: "优惠券名称",
          prop: "name",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "请输入优惠券名称",
            style: { 
              width: "240px",
            },
            maxLength: 15,
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",

              validator: (rule, value, callback) => {
                if (value === "") {
                  callback(new Error("请输入优惠券名称"));
                }
                const len = strLength(value);
                if (len < 3) {
                  callback(new Error("优惠券名称需3个字符以上"));
                }
                callback();
              },
            },
          },
          // afterSlot: () => (
          //   <span style="font-size:12px;margin-left:8px;color:#36a4d0;">
          //     示例？
          //   </span>
          // ),
        },
        {
          label: "优惠金额",
          prop: "discount_amount",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "请输入优惠金额",
            style: {
              width: "240px",
            },
            type: "number",
            class: "input_style",
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              validator: (rule, value, callback) => {
                if (value === "") {
                  callback(new Error("请输入优惠金额"));
                }
                if (value > 1000) {
                  callback(new Error("优惠金额不能超过1000元"));
                }
                callback();
              },
            },
          },
          afterSlot: () => (
            <span style="font-size:12px;margin-left:8px;">
              <span style="color:#666;margin-right:4px;">元</span>
              <span style="color:#666;margin-right:4px; color:red;">
                （提示：优惠金额大于课程实际售价时，优惠券将无法使用。）
              </span>
            </span>
          ),
        },
        {
          label: "使用门槛",
          prop: "discount_type",
          render: (row) => {
            return (
              <cusRadio
                styleType="flex"
                v-model={this.baseInfoForm.discount_type}
                data={[
                  {
                    id: 1,
                    type: "none",
                    title: "无门槛",
                  },
                  {
                    id: 2,
                    type: "input",
                    beforeName: "满",
                    afterName: "元使用",
                    placeholder: "1-9999",
                  },
                ]}
                useValue={this.baseInfoForm.min_pay_amount}
                onChangeValue={(e) => {
                  this.changeType(e, "use_value");
                }}
              ></cusRadio>
            );
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
            },
          },
        },
        {
          label: "使用须知",
          prop: "consume_desc",
          Component: "ElInput",
          defaultValue: "",
          componentProps: {
            placeholder: "请输入",
            style: {
              width: "240px",
            },
            type: "textarea",
            rows: 8,
            maxlength: 15,
            "show-word-limit": true,
          },
          formProps: {
            rules: {
              required: true,
              message:'请输入内容'
            },
          },
        },
      ],
      headerRule: [
        {
          label: "领取时间",
          prop: "get_time",
          Component: "ElDatePicker",
          defaultValue: "",
          componentProps: {
            type: "datetimerange",
            "range-separator": "-",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            style: {
              width: "360px",
            },
            format: "yyyy-MM-dd HH:mm:ss",
            "value-format": "yyyy-MM-dd HH:mm:ss",
            'picker-options':this.pickerOptions
          },
          formProps: {
            rules: {
              required: true,
              message:'请选择时间'
            },
          },
        },
        {
          label: "使用时间",
          prop: "valid_type",
          render: (row) => {
            return (
              <cusRadio
                styleType="block"
                v-model={this.useRuleForm.valid_type}
                data={[
                  {
                    id: 2,
                    type: "input",
                    beforeName: "领取后",
                    afterName: "天使用",
                    placeholder: "1-30",
                  },
                  {
                    id: 1,
                    type: "time",
                    beforeName: "时间段",
                  },
                ]}
                useValue={this.useRuleForm.valid_duration}
                timeRange={this.useRuleForm.use_time_range}
                onChangeValue={(e) => {
                  this.changeType(e, "use_time");
                }}
                onChangeValueRange={(e) => {
                  this.changeValueRange(e);
                }}
              ></cusRadio>
            );
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message:'请选择'
            },
          },
        },
        {
          label: "领取场景",
          prop: "getscene",
          Component: cusRadio,
          defaultValue: "",
          componentProps: {
            styleType: "flex",
            style: {
              width: 300,
              height: 200,
            },
            data: [
              {
                id: 1,
                type: "none",
                title: "直播间",
              },
              {
                id: 2,
                type: "none",
                title: "接口发放",
                bindObj: {
                  disabled: true
                }
              },
              {
                id: 3,
                type: "none",
                title: "平台活动发放",
                bindObj: {
                  disabled: true
                }
              },
              {
                id: 4,
                type: "none",
                title: "Im场景发放",
              },
            ],
          },
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message:'请选择'
            },
          },
        },
        {
          label: "使用范围",
          Component: virtualizedSelect,
          prop: "product_id",
          defaultValue: "",
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "选择添加的课程",
            },
            ...formProps,
          },
          componentProps: {
            // clearable:true,
            style: {
              width: "240px",
            },
            placeholder: "选择添加的课程",
            selectProps: {
              label: "title",
              value: "id",
              disable: "disabled",
            },
            disable: this.selDisable,
            httpRequest: async (params) => {
              let res = await this.getProductSelect(params);
              let data = {
                total: res.count,
                data: res.data,
              };
              this.useRuleForm.product_id = this.useRuleForm.product_id
                ? this.useRuleForm.product_id
                : data?.data[0]?.product_id;
              return data;
            },
          },
          afterSlot: () => (
            <span style="font-size:12px;margin-left:8px;">
              <span style="color:#36a4d0;margin-right:4px;">
                讲师在创建优惠券添加课程时做一个校验，课程价格不能小于优惠券价格；一个抖音券只能关联一个课程
              </span>
            </span>
          ),
        },
        {
          label: "",
          prop: "",
          defaultValue: "",
          formProps: {
            rules: {
              required: true,
              trigger: "blur",
              message: "选择抖音号",
            },
            ...formProps,
          },
          render: (row) => {
            return (
              <div class="footer_button">
                <el-button
                  class="btn_style"
                  type="primary"
                  onClick={() => {
                    this.addDyNum();
                  }}
                >
                  选择抖音号
                </el-button>
                {this.selectInfo.length > 0 && (
                  <div class="dy_warp_cons">
                    {this.selectInfo.map((item) => {
                      return (
                        <div class="warp_cons">
                          <img src={item.avatar} class="avatar" />
                          <span class="nickName">{item.nickname}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          },
        },
      ],
      dyGroupAuths: false,
      edit_id: "",
      dataArr:[]
    };
  },
  watch: {
  	'baseInfoForm.discount_type': {
  		deep: true,
  		handler(news,old) {
			if(news == 1){
				this.baseInfoForm.min_pay_amount = 0
			} else {
				this.baseInfoForm.min_pay_amount = ''
			}
  		}
  	}
  },
  computed: {
    pickerOptions() {
      let minDate = "";
      return {
        onPick: (obj) => {
          minDate = obj.minDate;
        },
        disabledDate: (time) => {
          if (minDate) {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = minDate.getTime() - one;
            const maxTime = minDate.getTime() + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      };
    },
  },
  created() {
    this.edit_id = this.$route.params.id ? this.$route.params.id : "";
    if (this.edit_id) {
      this.getDyCode()
      this.getContent()
    }
    this.$set(this.headerRule[0].componentProps,'picker-options',this.pickerOptions)
  },
  methods: {
    ...mapActions("coupon", ["couponCreate", "couponEditList","couponProduct","couponEdit"]),
    changeType(value, type) {
      console.log("changeType-----", type, value);
      if (type == "use_value") {
        this.baseInfoForm.min_pay_amount = value;
        return;
      }
      if (type == "use_time") {
        this.useRuleForm.valid_duration = value;
        return;
      }
    },
    changeValueRange(value) {
      this.useRuleForm.use_time_range = value;
    },
    async getProductSelect(params) {
      let res = await this.couponProduct({ ...params });
      console.log(res, "res----");
      return {
        data: res.data,
        count: res.count,
      };
    },
    addDyNum() {
      this.dyGroupAuths = true;
    },
    async getDyCode(){
      let res = await api.codeList.requestFun({}, "post", { "come-from": 1 });
      let data = [...res.available, ...res.overtime];
      this.dataArr = data;
      
    },
    submitForm() {
      let keys1 = cloneDeep(this.baseInfoForm);
      let keys2 = cloneDeep(this.useRuleForm);
      let datas = { ...keys1, ...keys2 };
      datas.receive_begin_time =
        datas.get_time && datas.get_time.length ? datas.get_time[0] : "";
      datas.receive_end_time =
        datas.get_time && datas.get_time.length ? datas.get_time[1] : "";
      delete datas.get_time;
      datas.valid_begin_time =
        datas.use_time_range && datas.use_time_range.length
          ? datas.use_time_range[0]
          : "";
      datas.valid_end_time =
        datas.use_time_range && datas.use_time_range.length
          ? datas.use_time_range[1]
          : "";
      delete datas.use_time_range;

      console.log(datas, "submitForm---data");
      this.getCreate(datas);
    },
    async getCreate(data) {
      if(this.edit_id){
        await this.couponEdit({id:this.edit_id,...data})
      }else{
        await this.couponCreate(data);
      }
      this.$message({
        type: "success",
        message: "保存成功",
      });
      this.$router.go(-1);
    },
    resetForm() {
      this.baseInfoForm = {
        name: "", //优惠券名称
        discount_amount: "",
        discount_type: 1, //优惠类型（1：立减券；2：满减券；）
        consume_desc: "", //使用须知 （长度15以内）
        min_pay_amount: 0, //满减门槛金额
      };
      this.useRuleForm = {
        get_time: [],
        valid_type: "", // 1：固定时间 2：领取后多少时间内有效
        valid_duration: "",
        use_time_range: [],
        getscene: 1,
        product_id: "",
        dycodeids: [],
      };
      this.$router.go(-1);
    },
    async getContent() {
      let res = await this.couponEditList({ id: this.edit_id });
      let values = cloneDeep(res);
      let get_time = [];
      values.receive_begin_time?get_time.push(values.receive_begin_time):0

      values.receive_end_time? get_time.push(values.receive_end_time):0
      values.get_time = get_time.length?get_time:[]
      delete values.receive_begin_time;
      delete values.receive_end_time;

      let use_time_range = [];
      values.valid_begin_time?use_time_range.push(values.valid_begin_time):0
      values.valid_end_time?use_time_range.push(values.valid_end_time):0
      values.use_time_range = use_time_range.length?use_time_range:[]
      delete values.valid_begin_time;
      delete values.valid_end_time;

      console.log(values, "editcontent----");
      for (const key in this.baseInfoForm) {
        this.baseInfoForm[key] = values[key];
      }

      for (const key in this.useRuleForm) {
        this.useRuleForm[key] = values[key];
      }

      this.useRuleForm.dycodeids.forEach((item) => {
        this.dataArr.forEach((val) => {
          if (val.id == item) {
            this.selectInfo.push(val)
          }
        });
      });
    },
  },
};
</script>

<style lang="less">
.courseInfo{
  display: flex;
  align-items: center;
}
.from_item_con {
  width: 100%;
  display: flex;
  justify-content: center;
}
.footer_button {
  // display: flex;
  // flex-direction: column;
}
.btn_style {
  display: block;
}
.dy_warp_cons {
  max-width: 240px;
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #eee;
  margin-top: 30px;
}
.warp_cons {
  display: flex;
  align-items: center;
  padding: 5px 20px;
  border-bottom: 1px solid #eee;
}
.warp_cons:last-child {
  border-bottom: none;
}
.avatar {
  width: 25px;
  height: 25px;
  margin-right: 10px;
  border-radius: 50%;
  display: block;
  flex-shrink: 0;
}
.nickName {
  flex: 1;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.add_warp{
  &::-webkit-scrollbar {
  width: 0;
  height: 10px;
}
}
</style>
